import Home from "../components/home/Home";
import Category from "../components/category/Category";
import Product from "../components/product/Product";
import Cart from "../components/cart/Cart";
import Checkout from "../components/checkout/Checkout";
import OrderReceipt from "../components/OrderReceipt";
import SearchProducts from "../components/SearchProducts";
import ContentPage from "../components/ContentPage";
import NotFound from "../components/NotFound";

import CustomerLogin from "../components/customer/CustomerLogin";
import CustomerLogout from "../components/customer/CustomerLogout";
import Customer from "../components/customer/Customer";
import PasswordRequest from "../components/customer/PasswordRequest";
import CreateAccount from "../components/customer/create/CreateAccount";

import AdminLogin from "../components/admin/login/AdminLogin";
import Admin from "../components/admin/Admin";

import AdminFileBrowser from "../components/admin/AdminFileBrowser";
// import AdminImageUploader from '../components/admin/AdminImageUploader'

// ===================================
//  CUSTOM
// ===================================
import JerseyForm from "../components/custom/jersey-form/JerseyForm";
import JerseyFormPrint from "../components/custom/jersey-form/JerseyFormPrint";

import { adminIsAuthenticated, adminIsNotAuthenticated, adminIsAuthenticatedNoLogin, customerIsAuthenticated, customerIsNotAuthenticated } from "./auth";

import GARouteWrapper from "../components/GARouteWrapper";

export default [
	{
		path: "/",
		exact: true,
		component: GARouteWrapper(Home)
	},
	{
		path: "/category/:permalink",
		component: GARouteWrapper(Category)
	},
	{
		path: "/:category/product/:permalink",
		component: GARouteWrapper(Product)
	},
	{
		path: "/cart",
		component: GARouteWrapper(Cart)
	},
	{
		path: "/checkout",
		component: GARouteWrapper(Checkout)
	},
	{
		path: "/order-summary",
		component: GARouteWrapper(OrderReceipt)
	},

	// ===================================
	//  CUSTOMER
	// ===================================
	{
		path: "/customer/login",
		component: customerIsNotAuthenticated(CustomerLogin)
	},
	{
		path: "/customer/logout",
		component: customerIsAuthenticated(CustomerLogout)
	},
	{
		path: "/customer/request-password",
		component: customerIsNotAuthenticated(PasswordRequest)
	},
	{
		path: "/customer/create",
		component: customerIsNotAuthenticated(CreateAccount)
	},
	{
		path: "/customer",
		component: customerIsAuthenticated(Customer)
	},

	// ===================================
	//  ADMIN
	// ===================================
	{
		path: "/admin/login",
		component: adminIsNotAuthenticated(AdminLogin)
	},
	{
		path: "/admin",
		component: adminIsAuthenticated(Admin)
	},

	// ===================================
	//  MISC
	// ===================================
	{
		path: "/image-browser",
		component: adminIsAuthenticatedNoLogin(AdminFileBrowser),
		exact: true
	},
	{
		path: "/file-browser",
		component: adminIsAuthenticatedNoLogin(AdminFileBrowser),
		exact: true
	},
	{
		path: "/search-results",
		component: SearchProducts
	},
	// {
	// 	path: '/image-uploader',
	// 	component: adminIsAuthenticatedNoLogin(AdminImageUploader),
	// 	exact: true
	// },
	// {
	// 	path: '/test',
	// 	component: ProductTest
	// },

	// ===================================
	//  CUSTOM
	// ===================================
	{
		path: "/jersey-form/print/:id",
		component: JerseyFormPrint
	},
	{
		path: "/jersey-form",
		component: JerseyForm
	},

	// ===================================
	//  MISC
	// ===================================
	{
		path: "/:permalink",
		component: ContentPage
	},
	{
		component: NotFound
	}
];



// WEBPACK FOOTER //
// ./src/shared/routes.js